import { DescriptionPrinterForPage } from "../../Components/Description/Tabs/DescriptionPrinterForPage";
import { DescriptionTabs } from "../../Components/Description/DescriptionTabs";
import { Page } from "../Product/Page";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";
import { AdminMenu } from "../../Components/Admin/AdminMenu";
import { PageFooter } from "../Main/PageFooter";


export class RentalPage extends Page
{
    constructor(_shop: ShopContentProvider)
    {
        super("Wypożyczalnia sprzętu detektywistycznego");

        this.Append(new PageFooter(_shop));

        this.Content(async (body) =>
        {
            await _shop.Load();

            body.Append(
                _shop.IsAuthorized && new AdminMenu({
                    "Edytuj stronę": "page/edit",
                }),

                new DescriptionTabs(_shop.Shop.RentalPageContent).MarginTopBottom(1.5, "rem").BorderRadius(0.5, "rem"),
                new DescriptionPrinterForPage(_shop.Shop.RentalPageContent),
            )
        });
    }
}
